/* eslint-disable jsx-a11y/anchor-has-content,react/no-unused-prop-types */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectCounts } from 'mt-react-common/modules/main/reducers/static/states/counts/reducer';

import CreateParticipateContestFormContainer from '../../containers/ParticipateContestFormContainer';

const ParticipateContestButton = props => (
  <div>
    <button
      className="btn btn-primary btn-block"
      type="submit"
      onClick={() => props.sendRequest()}
    >
      Участвовать
    </button>
  </div>
);

ParticipateContestButton.propTypes = {
  // IN
  contestId: PropTypes.number.isRequired,

  // CONNECT DISPATCH
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  counts: selectCounts(state)
});

export default CreateParticipateContestFormContainer(
  connect(mapStateToProps)(ParticipateContestButton)
);



// WEBPACK FOOTER //
// ./src/components/Contest/elements/ParticipateContestButton/ParticipateContestButton.js